"use strict";

import { forEach, isElement } from 'lodash';
import { subscribe } from '../../01-helpers/event-manager';
import { TOGGLE_TRIGGERED } from '../../02-const/event-names';

const moduleName = 'modal',
    selectors = {
        base: `.js-${moduleName}`,
        button: `.js-${moduleName}-button`
    };


export class Modal {

    constructor(baseElement) {
        this._config(baseElement);
        this._setup();
    }


    _openModal() {
        this.active = true;
        // open the modal
        this.baseElement.style.display = 'flex';
    }

    _closeModal() {
        this.active = false;
        // close the modal
        this.baseElement.style.display = 'none';
    }


    _onToggleTriggered() {
        if (this.active) {
            this._closeModal();
            // if modal is active, close the modal
        } else {
            // if modal is not active, open the modal
            this._openModal();
        }        
    }

    _bindEvents() {
        subscribe(TOGGLE_TRIGGERED, () => this._onToggleTriggered());

        forEach(this.buttons, (button) => {
            button.addEventListener('click', (evt) => this._onToggleTriggered(evt));
        });
    }

    _config(element) {
        if (!isElement(element)) {
            return false;
        }

        this.baseElement = element;
        this.buttons = this.baseElement.querySelectorAll(selectors.button);
        this.active = false;
    }

    _setup() {
        this._bindEvents();
    }
}

const initModal = () => {
    forEach(document.querySelectorAll(selectors.base), (modalElement) => {
        new Modal(modalElement);
    });
};

initModal();